export default "__VITE_ASSET__662c04c0__"